import type { ToolTipFnParams } from 'src/types'

export const fontFamily = 'GoogleSans-Regular'

export function tooltipFn({ head, label, val, color, percent = null }: ToolTipFnParams) {
  const str = !percent ? '' : `<div class="q-item__label text-caption float-right q-pt-sm q-pl-md" style="color: ${color}">${percent}%</div>`
  return `${'<div class="q-card bg-transparent q-card--flat no-shadow q-pa-sm">'
    + '<div class="q-card__section">'
    + '<div class="q-item__label text-weight-bold text-subtitle1 q-mb-md">'}${head}</div>`
    + `<div class="q-item__label text-body1 text-grey-7">${label}</div>`
    + `<div class="q-item__label text-h5 float-left" style="color: ${color}">${val}</div>${str}</div></div>`
}

export const legend = {
  position: 'bottom',
  fontSize: '14px',
  fontFamily,
  labels: { colors: '#757575' },
  itemMargin: { horizontal: 7 },
  markers: { width: 13, height: 13 },
}
